<template>
  <HeadlessTransitionRoot as="template" :show="isOpen">
    <HeadlessDialog
      as="div"
      class="relative z-10"
      @close="handleDialogOutsideClick"
    >
      <div class="fixed inset-0 bg-black/50" />
      <div class="fixed inset-0 overflow-hidden">
        <div class="absolute inset-0 overflow-hidden">
          <div
            class="pointer-events-none fixed inset-x-0 bottom-0 flex max-h-full max-w-full pt-12"
            :class="shrink ? '' : 'top-0'"
          >
            <HeadlessTransitionChild
              as="template"
              enter="transform transition ease-in-out duration-200 sm:duration-200"
              enter-from="translate-y-full"
              enter-to="translate-y-0"
              leave="transform transition ease-in-out duration-200 sm:duration-200"
              leave-from="translate-y-0"
              leave-to="translate-y-full"
            >
              <HeadlessDialogPanel
                class="pointer-events-auto relative w-screen flex-1 overflow-hidden rounded-t-xl bg-background shadow-lg"
              >
                <div class="flex h-full flex-col">
                  <div
                    class="mb-1 flex shrink-0 items-center justify-center pt-2"
                  >
                    <div
                      class="h-1 w-12 rounded-full bg-background-fg/10"
                    />
                  </div>
                  <template
                    v-if="$slots.header || $slots.title"
                  >
                    <slot name="header">
                      <DrawerHeader
                        @close="handleCloseDialog"
                      >
                        <slot name="title" />
                      </DrawerHeader>
                    </slot>
                  </template>

                  <slot />
                </div>
                <template v-if="isLoading">
                  <BaseInnerLoading />
                </template>
              </HeadlessDialogPanel>
            </HeadlessTransitionChild>
          </div>
        </div>
      </div>
    </HeadlessDialog>
  </HeadlessTransitionRoot>
</template>

<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    isOpen: boolean
    shrink?: boolean
    isLoading?: boolean
    disableClickOutside?: boolean
  }>(),
  {
    shrink: false,
    isLoading: false,
    disableClickOutside: false,
  }
)
const emit = defineEmits(["close"])

const handleCloseDialog = () => {
  if (props.isLoading) return
  emit("close")
}

const handleDialogOutsideClick = () => {
  if (props.disableClickOutside) return
  return handleCloseDialog()
}
</script>
